
import type { PropType } from 'vue'
import type { PopoverItem } from '../popover-list.component.vue'
import { defineComponent } from 'vue'

import { mapGetters } from 'vuex'

import { capitalizeSentence } from '../../filters'

import { CONFIG_CONSTS } from '../../store/config/config.consts'

import { UiRippleInk } from '../keen-ui'
import PopoverList from '../popover-list.component.vue'
import NavigationMenuHeaderEnvironment from './navigation-menu-header-environment.component.vue'

export enum AnimationStepEnum {
  INSTANCE,
  ENVIRONMENT,
  SECTION,
}

export enum LogoTypeEnum {
  IMAGOTYPE = 'imagotype',
  ISOTYPE = 'isotype',
}

export default defineComponent({
  name: 'NavigationMenuHeader',
  components: {
    PopoverList,
    UiRippleInk,
    NavigationMenuHeaderEnvironment,
  },
  props: {
    items: {
      type: Array as PropType<Array<PopoverItem>>,
      default: () => [],
    },
    collapsible: Boolean,
    collapsed: Boolean,
    collapsedInState: Boolean,
    disabled: Boolean,
    animationDurationInMillis: Number,
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      instanceConfig: CONFIG_CONSTS.getters.currentInstance,
      instances: CONFIG_CONSTS.getters.instances,
    }),
    componentClasses() {
      return {
        'epb-navigation-menu-header--collapsible': this.collapsible,
        'epb-navigation-menu-header--collapsed': this.collapsed,
        'epb-navigation-menu-header--collapsed-in-state': this.collapsedInState,
      }
    },
    instanceName(): string {
      return this.instanceConfig.prettyName || capitalizeSentence(this.instanceConfig.id)
    },
    showPopoverIcon(): boolean {
      return !this.collapsed && (!!this.items.length || this.showInstancesSelector)
    },
    showInstancesSelector(): boolean {
      return this.instances && this.instances.length > 1
    },
  },
  data() {
    return {
      showPopover: false,
      AnimationStepEnum,
      LogoTypeEnum,
    }
  },
  watch: {
    collapsed(): void {
      if (this.$refs.popoverList) {
        this.$refs.popoverList.close()
      }
      this.onClosePopoverList()
    },
  },
  methods: {
    getItemStyle(index: number) {
      let animationSteps = 2
      if (this.collapsed) {
        animationSteps -= 1
      }
      const itemTransitionDurationInMillis = this.animationDurationInMillis / animationSteps
      return {
        transitionDuration: `${itemTransitionDurationInMillis}ms`,
        transitionDelay: `${itemTransitionDurationInMillis * index}ms`,
      }
    },
    getLogoUrl(logoType: LogoTypeEnum): string {
      return (
        (!!this.instanceConfig.logoUrls && this.instanceConfig.logoUrls[logoType]) ||
        this.getDefaultLogoUrl(logoType)
      )
    },
    onImageError(logoType: LogoTypeEnum, event): void {
      event.target.src = this.getDefaultLogoUrl(logoType)
    },
    getDefaultLogoUrl(logoType: LogoTypeEnum): string {
      const defaultLogoUrls = this.$epb.customization.logos
      return {
        [LogoTypeEnum.IMAGOTYPE]: defaultLogoUrls.imagotype,
        [LogoTypeEnum.ISOTYPE]: defaultLogoUrls.isotype || defaultLogoUrls.imagotype,
      }[logoType]
    },
    onClickPopoverList(item: PopoverItem): void {
      this.$router.push(item.route)
    },
    onOpenPopoverList(): void {
      this.showPopover = true
    },
    onClosePopoverList(): void {
      this.showPopover = false
    },
  },
})
